// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6218":"2545c60a","8451":"2545c60a"}[chunkId] + ".chunk.css";
};